import { render, staticRenderFns } from "./ContainerDetail.vue?vue&type=template&id=236e8562&scoped=true"
import script from "./ContainerDetail.vue?vue&type=script&lang=js"
export * from "./ContainerDetail.vue?vue&type=script&lang=js"
import style0 from "./ContainerDetail.vue?vue&type=style&index=0&id=236e8562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236e8562",
  null
  
)

export default component.exports